import PubSub from 'pubsub-js';

import { scrollTop } from '../utils';

const $html = $('html');

PubSub.subscribe('init', () => {
    const searchParams = new URLSearchParams(window.location.search);
    const anchor = searchParams.get('anchor');
    const device = $html.data('device');
    if (anchor) {
        sessionStorage.clear();
        if (device === 'pc') {
            PubSub.publish('top.updateBackground', anchor);
        } else {
            const target = $(`.content[data-id="${anchor}"]`);
            scrollTop(target.offset().top);
        }
    }

    let sessionScene = sessionStorage.getItem('scene');
    if (sessionScene) {
        if (device === 'pc') {
            if (sessionScene.match(/strength/)) {
                sessionScene = 'strength';
            }
            PubSub.publish('top.updateBackground', sessionScene);
        }
        sessionStorage.clear();
    }
});